import AuthHeaderKeyboardAvoidingView from '@/components/Auth/AuthHeaderKeyboardAvoidingView'
import AuthLicenceIdField from '@/components/Auth/Licence/AuthLicenceIdField'
import TitleWithHint from '@/features/auth/components/TitleWithHint'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const AuthLicenceScreen: FC = () => {
    const { t } = useTranslation()

    return (
        <AuthHeaderKeyboardAvoidingView>
            <TitleWithHint
                title={t('authScreensDeviceAuthorization')}
                hint={t('licenceVerificationScreenEnterLicenceId')}
            />
            <AuthLicenceIdField />
        </AuthHeaderKeyboardAvoidingView>
    )
}

export default AuthLicenceScreen
